/**
 * Delete Account Confirmation Modal Component
 *
 * Displays confirmation dialog for account deletion.
 */

import React from 'react';
import { Modal } from '@/shared/ui/components/Modal';
import { Button } from '@/shared/ui/components/Button';
import type { AccountDeleteState } from '../model/types';

interface DeleteAccountModalProps {
  state: AccountDeleteState;
}

export const DeleteAccountModal: React.FC<DeleteAccountModalProps> = ({ state }) => {
  const { isOpen, selectedAccount, isDeleting, close, confirm } = state;

  if (!isOpen || !selectedAccount) return null;

  return (
    <Modal isOpen={true} onClose={close}>
      <div className="p-6">
        <h3 className="text-lg font-semibold mb-4">계정 삭제</h3>
        <p className="text-gray-600 mb-6">
          정말로 <strong>{selectedAccount.account_id}</strong> 계정을 삭제하시겠습니까?
          <br />
          이 작업은 되돌릴 수 없습니다.
        </p>
        <div className="flex justify-end space-x-3">
          <Button type="button" variant="outline" onClick={close} disabled={isDeleting}>
            취소
          </Button>
          <Button type="button" variant="danger" onClick={confirm} disabled={isDeleting}>
            {isDeleting ? '삭제 중...' : '삭제'}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

DeleteAccountModal.displayName = 'DeleteAccountModal';
